import { useNavigate } from "@entry/navigation";

import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Routes } from "@ctypes";
import { EntryStepLayout } from "@entry/EntryStepLayout";
import { useTheme } from "@hooks";
import { Translations, i18n } from "@i18n";
import { CheckMark } from "@routes/AllocateFundsRoute/AllocateFundsSuccessModal/CheckMark";
import { styles } from "./styles";

export const ForgotPasswordConfirmationRoute = () => {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.ForgotPasswordConfirmationRouteTitle),
    subtitle: i18n.t(Translations.ForgotPasswordConfirmationRouteSubtitle),
    cta: {
      primary: {
        title: i18n.t(Translations.ForgotPasswordConfirmationRoutePrimaryCTA),
        onClick: () => {
          navigate(Routes.EmailLogin, { replace: true });
        },
      },
    },
  };

  return (
    <EntryStepLayout {...props}>
      <div style={{ display: "flex", justifyContent: "center", ...styles.text }}>
        <CheckMark background={theme.button.background.primary} />
      </div>
    </EntryStepLayout>
  );
};
